var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        { staticClass: "mb-5 justify-content-end" },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-end mt-2 col-lg-2 col-xl-2 col-4",
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter_2 mx-3",
                  attrs: { variant: "primary" },
                  on: { click: _vm.trigOnImportCSV },
                },
                [
                  _c("i", { staticClass: "fa-light fa-plus" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "fab-label" }, [
                    _vm._v(_vm._s(_vm.$t("toolbox.import_testcase"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                ref: "fileInput",
                staticClass: "d-none",
                attrs: { type: "file", accept: ".csv" },
                on: { change: _vm.onImportCSV },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-2", attrs: { cols: "4", lg: "2", xl: "2" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter",
                  on: {
                    click: function ($event) {
                      _vm.displayFilter = !_vm.displayFilter
                    },
                  },
                },
                [
                  _vm.displayFilter
                    ? _c("i", { staticClass: "fa-light fa-minus" })
                    : _c("i", { staticClass: "fa-light fa-plus" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("filter.fltr")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-2", attrs: { cols: "4", lg: "2", xl: "2" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "btnFilter",
                  on: {
                    click: function ($event) {
                      return _vm.refreshInbox()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa-light fa-rotate-right" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.rfrsh")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "mx-auto" }),
      _vm._v(" "),
      _vm.displayFilter
        ? _c(
            "b-row",
            {
              staticClass: "min-w-100 justify-content-start align-items-center",
            },
            [
              _c(
                "b-col",
                { staticClass: "filter-item", attrs: { sm: "6", lg: "2" } },
                [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "filter-item-title d-block mb-1" },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("injection_tab.select_t_c_result"))
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.StatusFilter,
                            expression: "StatusFilter",
                          },
                        ],
                        staticClass: "filter-item-content w-100",
                        staticStyle: { padding: "0.5rem" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.StatusFilter = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "", selected: "" } }, [
                          _vm._v("----------"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "2" } }, [
                          _vm._v(_vm._s(_vm.$t("toolbox.filtre_status_ok"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "0" } }, [
                          _vm._v(_vm._s(_vm.$t("toolbox.filtre_status_ko"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "3" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("toolbox.filtre_status_missing_conf"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "4" } }, [
                          _vm._v(_vm._s(_vm.$t("account_tb.status.RUN"))),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "5" } }, [
                          _vm._v(_vm._s(_vm.$t("account_tb.status.NULL"))),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "filter-item", attrs: { sm: "6", lg: "2" } },
                [
                  _c("input-filter-dropdown-list", {
                    attrs: {
                      "reset-trigger": _vm.resetSignal,
                      label: _vm.$t("toolbox.filtre_case_summary"),
                      "item-list": _vm.AllRowName,
                      "trad-path": "toolbox.req_summary_case",
                    },
                    on: { "update-val": _vm.updateVal },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "2" } }, [
                _c(
                  "div",
                  [
                    _c(
                      "span",
                      { staticClass: "filter-item-title d-block mb-1" },
                      [_vm._v(_vm._s(_vm.$t("injection_tab.date_begin")))]
                    ),
                    _vm._v(" "),
                    _c("datetime-picker-custom", {
                      staticClass: "mr-3",
                      class: {
                        "filter-item-input": true,
                        "filter-item-input-complete": _vm.dateBeginFilter,
                      },
                      attrs: {
                        format: "YYYY-MM-DD HH:mm:ss",
                        periodFull: "",
                        id: "filter-datebegin",
                        customInputParentClass: "filter-item-content",
                        customInputClass: "w-100",
                        maxLength: 19,
                        placeholderValue: _vm.$t(
                          "common.datetime_picker_empty_date"
                        ),
                        inputIcon: "fa-solid fa-calendar",
                      },
                      model: {
                        value: _vm.dateBeginFilter,
                        callback: function ($$v) {
                          _vm.dateBeginFilter = $$v
                        },
                        expression: "dateBeginFilter",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "2" } }, [
                _c(
                  "div",
                  [
                    _c(
                      "span",
                      { staticClass: "filter-item-title d-block mb-1" },
                      [_vm._v(_vm._s(_vm.$t("injection_tab.date_end")))]
                    ),
                    _vm._v(" "),
                    _c("datetime-picker-custom", {
                      staticClass: "mr-3",
                      class: {
                        "filter-item-input": true,
                        "filter-item-input-complete": _vm.dateEndFilter,
                      },
                      attrs: {
                        format: "YYYY-MM-DD HH:mm:ss",
                        periodFull: "",
                        id: "filter-datebegin",
                        customInputParentClass: "filter-item-content",
                        customInputClass: "w-100",
                        maxLength: 19,
                        placeholderValue: _vm.$t(
                          "common.datetime_picker_empty_date"
                        ),
                        inputIcon: "fa-solid fa-calendar",
                      },
                      model: {
                        value: _vm.dateEndFilter,
                        callback: function ($$v) {
                          _vm.dateEndFilter = $$v
                        },
                        expression: "dateEndFilter",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("b-col"),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex justify-content-end align-items-center mt-4 px-0",
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass:
                            "btnResetFilter mr-2 px-3 py-1 w-auto col-6",
                          attrs: { disabled: !_vm.hasInputFilter },
                          on: { click: _vm.clearFilterFields },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("injection_tab.reset")) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "btnDoFilter px-3 py-1 w-auto col-6",
                          attrs: { variant: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.applyFilter()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("common.srch")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.displayFilter
        ? _c("b-row", {
            staticClass: "min-w-100 justify-content-end mb-5 mr-1",
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.displayFilter ? _c("hr", { staticClass: "mx-auto mb-4" }) : _vm._e(),
      _vm._v(" "),
      _vm.activateSpinner
        ? _c("spinner")
        : _vm.RequestList.length
        ? _c(
            "div",
            { staticStyle: { overflow: "auto" } },
            [
              _c("b-table", {
                staticClass: "table table-striped",
                staticStyle: { "margin-bottom": "0" },
                attrs: {
                  hover: "",
                  fields: _vm.fields,
                  items: _vm.RequestList,
                  selectable: _vm.RequestList.length > 0,
                  "per-page": _vm.paginationObject.maxResults,
                  "current-page": _vm.pageCounter,
                  "empty-text": _vm.$t("common.security.no_result"),
                },
                on: { "row-clicked": _vm.seeRequestTBDetails },
                scopedSlots: _vm._u([
                  {
                    key: "cell(response_request)",
                    fn: function (data) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " + _vm._s(data.item.ids_dataset.length) + " "
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(case_summary)",
                    fn: function (data) {
                      return [
                        _c("div", { staticClass: "py-3 w-auto" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  `toolbox.req_summary_case.${data.item.case_summary}`
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(description_case)",
                    fn: function (data) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  `toolbox.req_description_case.${data.item.description_case}`
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(case_type)",
                    fn: function (data) {
                      return [
                        _c("div", { staticClass: "py-3 w-auto" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  `toolbox.req_case_type.${data.item.case_type}`
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(lastExec)",
                    fn: function (data) {
                      return [
                        _c("div", { staticClass: "py-3 w-auto" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("formatDateTime")(data.value)) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "cell(case_type_detailed)",
                    fn: function (data) {
                      return [
                        data.item.case_type_detailed.length > 0
                          ? _c("div", { staticClass: "py-3 w-auto" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      `toolbox.req_case_type_detailed.${data.item.case_type_detailed}`
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _c("div", { staticClass: "py-3 w-auto" }),
                      ]
                    },
                  },
                  {
                    key: "cell(status)",
                    fn: function (data) {
                      return [
                        data.value === "2"
                          ? _c("div", [
                              _c("i", {
                                staticClass:
                                  "fas fa-check bg-success text-white",
                                staticStyle: {
                                  "border-radius": "50%",
                                  display: "inline-flex",
                                  "justify-content": "center",
                                  "align-items": "center",
                                },
                                attrs: { title: "OK" },
                              }),
                            ])
                          : data.value === "0"
                          ? _c("div", [
                              _c("i", {
                                staticClass:
                                  "fas fa-multiply bg-danger text-white",
                                staticStyle: {
                                  "border-radius": "50%",
                                  display: "inline-flex",
                                  "justify-content": "center",
                                  "align-items": "center",
                                },
                                attrs: { title: "KO" },
                              }),
                            ])
                          : data.value === "1"
                          ? _c("div", [
                              _c("i", {
                                staticClass: "fas fa-hourglass-half text-white",
                                staticStyle: {
                                  "background-color": "orange",
                                  "border-radius": "50%",
                                  display: "inline-flex",
                                  "justify-content": "center",
                                  "align-items": "center",
                                },
                                attrs: { title: "RUN" },
                              }),
                            ])
                          : data.value === "3"
                          ? _c("div", [
                              _c("i", {
                                staticClass: "fas fa-file-alt",
                                staticStyle: {
                                  color: "gray",
                                  "font-size": "20px",
                                },
                                attrs: { title: "Missing configuration" },
                              }),
                            ])
                          : data.value === "4"
                          ? _c("div", [
                              _c("i", {
                                staticClass: "fas fa-hourglass-half",
                                staticStyle: {
                                  color: "gray",
                                  "font-size": "20px",
                                },
                                attrs: { title: "RUNNING" },
                              }),
                            ])
                          : data.value === "5"
                          ? _c("div", [
                              _c("i", {
                                staticClass:
                                  "fas fa-minus bg-secondary text-white",
                                staticStyle: {
                                  "border-radius": "50%",
                                  display: "inline-flex",
                                  "justify-content": "center",
                                  "align-items": "center",
                                },
                                attrs: { title: "Not tested" },
                              }),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          )
        : _c("div", { staticClass: "d-flex justify-content-center" }, [
            _c("span", { staticClass: "noResult" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("common.no_result")) + "\n    "
              ),
            ]),
          ]),
      _vm._v(" "),
      !_vm.activateSpinner && _vm.RequestList.length
        ? _c(
            "b-row",
            { staticClass: "mt-5" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("cm-pagination", {
                    attrs: {
                      maxResultsByPage: _vm.paginationObject.maxResults,
                      firstIndex: _vm.paginationObject.firstIndex,
                      nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                      refreshEvent: _vm.paginationObject.refresh,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }